/*
 * Copyright © 2018-2021, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

export const notificationTypeSv = {
  CLINIC_DATA_EXPORT_CREATED: "När en klinikdataexport har skapats",
  CLINIC_EMPLOYMENT_REQUEST: "När jag blir inbjuden att arbeta på en klinik",
  CLINIC_EMPLOYMENT_REQUEST_ACCEPTED: "När någon accepterar min inbjudan att gå med i min klinik",
  CLINIC_EMPLOYMENT_REQUEST_REJECTED: "När någon avböjer min inbjudan att gå med i min klinik",
  CLINIC_EMPLOYMENT_REQUEST_REVOKED: "När min inbjudan att arbeta på en klinik återkallas",
  INVOICE_CREATED: "När en ny faktura har skapats",
  INVOICE_PAYMENT_REMINDER: "När en fakturabetalning förfaller",
  LINKED_UNREGISTERED_PETS: "När mitt husdjurs data registreras på en ny klinik",
  MEDICAL_RECORD_CREATED: "När en ny journal har skapats",
  PAYMENT_FAILED: "När en GlobalVET-fakturabetalning misslyckas",
  PAYMENT_SUCCEEDED: "När en GlobalVET-fakturabetalning lyckas",
  PET_OWNER_INVITATION: "När en djurägare blir inbjuden",
  PET_TRANSFER_INVITATION: "När en djurägare bjuder in mig att ta över deras djur",
  PET_TRANSFER_NEW_OWNER: "När ett djur överförs till mig",
  PET_TRANSFER_OLD_OWNER: "När den nya ägaren accepterar överföringen av mitt djur",
  PET_TRANSFER_REJECTED: "När en begäran om djuröverföring avvisas",
  POLICY_CHANGE: "När GlobalVET:s villkor har ändrats",
  RESERVATION_CANCELLED: "När min bokade tid avbokas",
  RESERVATION_CANCELLED_BY_OWNER: "När en tid avbokas av en djurägare på min klinik",
  RESERVATION_CREATED: "När en ny tid har bokats",
  RESERVATION_MODIFIED: "När detaljerna för min bokade tid ändras",
  RESERVATION_REMINDER: "När min bokade tid närmar sig",
  TRIAL_END_REMINDER: "När min provperiod snart är slut",
  VET_PROFESSION_APPROVED: "När mitt uppladdade veterinärdokument har godkänts",
  VET_PROFESSION_REJECTED: "När mitt uppladdade veterinärdokument har avslagits",

  ANNOUNCEMENT: "Meddelande",
  SYSTEM_INFORMATION: "Systeminformation",
  MARKETING: "Marknadsföring och kampanjer",
  CUSTOM: "Anpassat meddelande",
};
